import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { choices } from "../config-generics/aeKao";

export const whanauConfig: PageConfig[] = [
  {
    name: "whanau",
    title: "Whānau",
    questions: [
      {
        type: "matrixdynamic",
        name: "whanau",
        title: "Whānau",
        description:
          "Please provide all details for the whānau residing in your household",
        addRowText: "Add another whānau member",
        columnMinWidth: "130px",
        cellType: "radiogroup",
        columns: [
          {
            name: "registered",
            cellType: "dropdown",
            title: "Registered Member",
            choices,
          },
          {
            name: "name",
            cellType: "text",
            title: "Full Name",
          },
          {
            name: "age",
            title: "Age",
            cellType: "string",
          },
          {
            name: "conditions",
            cellType: "dropdown",
            title: "Relevant Medical Conditions",
            choices,
          },
          {
            name: "conditionDetails",
            title: "Condition Details",
            cellType: "string",
            visibleIf: "{row.conditions} = 'Āe'",
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
    ],
  },
  {
    name: "level",
    title: "Current Reo Level",
    questions: [
      {
        name: "level",
        type: "rating",
        title: "Please rate you and your whanau, current reo level",
        description: `
        With 1 being ‘no reo used in the home’ and 5 being ‘very confident/fluent,
        the only language spoken in our kāinga'
      `,
        rateValues: [1, 2, 3, 4, 5],
        isRequired: true,
      },
    ],
  },
];
